module.exports = __webpack_public_path__ + "img/228.kitchen_cleanliness.d8801345.svg";